// Components==============
import { faEye } from '@fortawesome/pro-regular-svg-icons';
import { faCheckCircle, faGlobe } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Label from 'components/UI/Label/Label';
import Tooltip from 'components/UI/Tooltip/Tooltip';
import { motion } from 'framer-motion';
import { usePermission } from 'hooks/usePermission';
import { useRedux } from 'hooks/useRedux';
import { useTranslate } from 'hooks/useTranslate';
import React, { useContext } from 'react';
import { useHistory } from 'react-router';
import { framerMountAndScale } from 'utilities/FramerAnimations';
import { getSmartImage } from 'utilities/getSmartImage';
import { ProjectCardContext } from '../../ProjectCard';
import './Card.module.scss';
// =========================

export default function Card({ style }: { style?: React.CSSProperties }) {
  const {
    theme,
    categories,
    withModal,
    setThemeModalIsOpen,
    completed,
    register,
  } = useContext(ProjectCardContext);
  const translate = useTranslate();
  const history = useHistory();

  const userId = useRedux((state) => state.authentication?.user?.id);

  function handleClick() {
    if (register) {
      return false;
    }
    if (withModal) {
      return setThemeModalIsOpen(true);
    }
    return history.push(`/werkplaats/project-details/${theme?.project?.id}`);
  }

  // const date = theme?.created_at
  //   ? new Date(theme?.created_at?.split(' ')[0]).toLocaleDateString('nl')
  //   : null;

  const firstImage = theme?.attachments
    .filter((a) => a.attachment_type === 'image')
    .map((a) => JSON.parse(a.attachment_data).file_path)[0] as
    | string
    | undefined;

  const isTeacher = usePermission(['Docent', 'super-admin', 'Extern']);

  const studentProjects = theme?.allProjects?.filter(
    (p) => p.created_by !== userId
  );

  const teachers = theme?.project?.members?.length
    ? theme.project.members.filter((m) => m.membership === 'teacher')
    : [];

  return (
    <motion.div
      {...framerMountAndScale}
      styleName="wrapper"
      onClick={handleClick}
      style={{ ...style }}
    >
      {theme?.public && !withModal ? (
        <div styleName="public">
          <Tooltip
            content={translate('project.visibility.library.description-alt')}
            position="right"
            noPointer
          >
            <FontAwesomeIcon icon={faGlobe} />
          </Tooltip>
        </div>
      ) : null}
      <div styleName="image">
        {!!firstImage && (
          <img alt={theme?.name} src={getSmartImage(firstImage)} />
        )}
      </div>
      <div styleName="right">
        <div styleName="top">
          <h2>
            {!!completed && <FontAwesomeIcon icon={faCheckCircle} />}{' '}
            {theme?.name}
          </h2>
          <div styleName="labels">
            {theme?.categories.map((cat, i) => {
              if (i > 3) return;

              return (
                <Label key={cat} type="grey">
                  {isNaN(cat)
                    ? cat.name
                    : categories?.find((c) => c?.id === cat)?.name}
                </Label>
              );
            })}
            {theme?.categories && theme?.categories?.length > 4 && (
              <Label type="grey">{`+ ${theme?.categories.length - 4}`}</Label>
            )}
          </div>
        </div>
        <div styleName="project-bottom">
          <div styleName="author">
            <p>{`${theme?.author?.first_name} ${theme?.author?.last_name}`}</p>
            {/* <p>{date}</p> */}
          </div>
          <>
            {withModal ? (
              <>
                {theme?.allProjects?.length ? (
                  <p styleName="bottom-text">
                    {theme?.allProjects.length === 1 &&
                      `1 ${translate('project.terms.process')}`}
                    {theme?.allProjects.length > 1 &&
                      `${theme?.allProjects.length} ${translate(
                        'project.terms.processes'
                      )}`}
                  </p>
                ) : null}
              </>
            ) : isTeacher ? (
              <>
                {!!studentProjects?.length && (
                  <p styleName="bottom-text">
                    {studentProjects.length}{' '}
                    {studentProjects.length > 1
                      ? translate('project.terms.processes')
                      : translate('project.terms.process')}
                  </p>
                )}
              </>
            ) : (
              <>
                {!!teachers.length && (
                  <div styleName="bottom-text">
                    <Tooltip
                      content={<p>{translate('project.teacher-process')}</p>}
                    >
                      <div styleName="teacher">
                        <FontAwesomeIcon icon={faEye} />{' '}
                        <p>
                          {teachers.map(
                            (t, i) =>
                              `${t.user.first_name} ${t.user.last_name}${
                                teachers.length - 1 === i ? '' : ','
                              } `
                          )}
                        </p>
                      </div>
                    </Tooltip>
                  </div>
                )}
              </>
            )}
          </>
        </div>
      </div>
    </motion.div>
  );
}
